// extracted by mini-css-extract-plugin
module.exports = {"docs":"Docs_docs__3XhBq","docs__title":"Docs_docs__title__Fn4_I","docs__titleSecond":"Docs_docs__titleSecond__DnyIP","docs__item":"Docs_docs__item__360ju"};